import styles from '@/styles/components/teases/PostTease.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { Button } from '@/components/controls/Button'
import { ImageLoaderProps } from 'next/image'
import type { Thumbnail } from '@/types/index'
import { useQuery } from '@/utils/url'

interface Props {
  title: string,
  slug: string,
  date: string,
  excerpt: string,
  thumbnail: Thumbnail
}

const loader = ({ src, width, quality }: ImageLoaderProps) => {
  return `${process.env.NEXT_PUBLIC_DO_SPACES}${src}?w=${width}&q=${quality || 75}`
}

const PostTease: React.FC<Props> = ({ title, slug, date, excerpt, thumbnail }) => {
  return (
    <Link href={useQuery(`/post/${slug}`)} passHref>
      <a>
        <div className={styles.tease_post}>
          <div className={styles.tease_post_wrapper}>
            <Image
              loader={loader}
              src={thumbnail.url}
              alt={thumbnail.alt}
              width="740"
              height="520"
              layout='responsive'
              objectFit='contain'
            />
          </div>
          <div className={styles.tease_post_content}>
            <h3 className={styles.tease_post_title}>{title}</h3>
            <p className={styles.tease_post_excerpt}>{excerpt}</p>
            <Button type="secondary">Read more</Button>
          </div>
        </div>
      </a>
    </Link>
  )
}

export default PostTease
